/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetActivecategorymenustate Input Action
 */
export class GetCurrentEventInput implements Msdyn365.IActionInput {
    // TODO: Determine if the results of this get action should cache the results and if so provide.
    // A cache object type and an appropriate cache key.
    public getCacheKey = () => `CurrentEvent`;
    public getCacheObjectType = () => 'CurrentEvent';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action.
export interface IGetCurrentEventStateData {
    eventJson: string;
}

/**
 * TODO: Use this function to create the input required to make the action call.
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCurrentEventInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getCurrentEventStateAction(input: GetCurrentEventInput, ctx: Msdyn365.IActionContext): Promise<IGetCurrentEventStateData> {
    // TODO: Uncomment the below line to get the value from a service.
    // const response = await Msdyn365.sendRequest<IGetActivecategorymenustateData[]>('/get/example/id/1', 'get');
    return { eventJson: '' };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCurrentEventStateData>>getCurrentEventStateAction,
    // TODO: Give your data action a unique id.
    id: 'GetCurrentEventStateActionState',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action.
    // isBatched: true
});
